import { render, staticRenderFns } from "./step-4.vue?vue&type=template&id=ce54b6ea&scoped=true&"
import script from "./step-4.vue?vue&type=script&lang=js&"
export * from "./step-4.vue?vue&type=script&lang=js&"
import style0 from "./step-4.vue?vue&type=style&index=0&id=ce54b6ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce54b6ea",
  null
  
)

export default component.exports